import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { BillingFormValues } from '@features/billing/BillingBox/formConfig'

interface Props {
  onValuesChange: (newValues: BillingFormValues, isValid: boolean) => void
  onStripeSubmit: boolean
}

export const SyncValuesWithParent: React.FC<Props> = ({
  onValuesChange,
  onStripeSubmit,
}) => {
  const { values, isValid, submitForm } = useFormikContext<BillingFormValues>()

  useEffect(() => {
    if (onStripeSubmit) {
      submitForm()
    }
  }, [onStripeSubmit])

  useEffect(() => {
    onValuesChange(values, isValid)
  }, [values, isValid])

  return null
}
